import { useQuery, useQueryClient } from '@lumapps/base-api/react-query';

import { getQueryMetadataList } from '../api';
import type { QueryMetadataListOptions } from '../types';

/**
 * List metadata (from instance or customer)
 */
export const useQueryMetadataList = (params: QueryMetadataListOptions, enabled = true) => {
    const queryClient = useQueryClient();
    return useQuery(getQueryMetadataList(queryClient, params, enabled));
};
